/** Texte statique pour le HTML SEO (pages sans fiche service dédiée). */
export type StaticPageCopy = {
  paragraphs: string[];
  sections?: { title: string; body: string[] }[];
  faq?: { q: string; a: string }[];
  navLinks?: { href: string; label: string }[];
};

export const STATIC_PAGE_COPY: Record<string, StaticPageCopy> = {
  '/': {
    paragraphs: [
      'Lbenna Prod est un studio de production audiovisuelle événementielle en Tunisie, fondé en 1988 à Tunis. Nous accompagnons mariages, entreprises et marques avec reportage photographique, films de mariage, location photobooth, production vidéo corporate et shooting studio. Notre équipe intervient à Tunis, Djerba, Ariana, Sfax, Sousse et dans l\'ensemble du territoire tunisien.',
      'Que vous prépariez un mariage destination à Djerba, un gala corporate au Lac ou une production audiovisuelle premium pour immortaliser votre événement, vous bénéficiez d\'un interlocuteur unique, d\'une préparation rigoureuse et d\'une post-production exigeante. Devis gratuit sous 24 h.',
    ],
    sections: [
      {
        title: 'Studio créatif, mariage et production audiovisuelle',
        body: [
          'Le mariage reste le cœur de notre métier. Nous proposons des formules photo, vidéo ou duo photo-vidéo avec couverture complète : préparatifs, cérémonie religieuse ou civil, soirée et options drone. Nos photographes maîtrisent la lumière naturelle des plages de Djerba comme les réceptions en salle à Tunis et en banlieue nord.',
          'Nos films de mariage mêlent captation documentaire et montage cinématographique. Teaser pour les réseaux sociaux, film long format et rendu premium : chaque livrable est pensé pour durer. Découvrez nos reportages sur la page mariage ou notre portfolio mariage.',
          'En complément, nous réalisons des shootings studio, packshots e-commerce et portraits professionnels avec retouche incluse — la même exigence artistique que sur le terrain.',
        ],
      },
      {
        title: 'Photobooth, corporate et zones d\'intervention',
        body: [
          'Notre photobooth anime mariages et soirées d\'entreprise avec photos HD, fond personnalisé et galerie en ligne. Location disponible à Tunis, Djerba et partout en Tunisie — animation clé en main avec animateur professionnel.',
          'En production corporate, nous réalisons films institutionnels, captation de conférences, interviews dirigeants et contenus digital. Intervention à Tunis, Ariana, La Marsa, Lac, Djerba, Sousse et Sfax.',
          'Basés à Tunis avec déplacements fréquents à Djerba, nous connaissons les contraintes logistiques des hôtels, riads et salles de réception tunisiennes. Matériel 4K, drone, stabilisateur et éclairage professionnel.',
        ],
      },
      {
        title: 'Pages services locales — trouvez votre prestation',
        body: [
          'Consultez nos pages dédiées : photobooth Tunisie, photographe mariage Djerba, photographe événementiel Tunis, production vidéo corporate.',
          'Chaque page détaille nos formules, FAQ et zones couvertes. Portfolio par univers : mariage, photobooth, corporate et shooting studio. Contactez-nous pour un devis personnalisé — réponse garantie sous 24 h ouvrées.',
        ],
      },
    ],
    faq: [
      {
        q: 'Où intervenez-vous en Tunisie ?',
        a: 'Principalement à Tunis, Ariana, La Marsa et Djerba, avec déplacements à Sfax, Sousse, Hammamet et sur demande dans toute la Tunisie.',
      },
      {
        q: 'Proposez-vous photo et vidéo le même jour ?',
        a: 'Oui, nos formules duo photo-vidéo sont coordonnées par un chef de projet unique.',
      },
      {
        q: 'Quel est le délai pour un devis ?',
        a: 'Nous répondons sous 24 h avec une proposition détaillée adaptée à votre date et votre lieu.',
      },
      {
        q: 'Livrez-vous les fichiers en ligne ?',
        a: 'Oui, galerie privée haute définition incluse dans nos formules mariage et corporate.',
      },
    ],
    navLinks: [
      { href: '/services', label: 'Services' },
      { href: '/mariage', label: 'Mariage' },
      { href: '/photobooth-tunisie', label: 'Photobooth Tunisie' },
      { href: '/photographe-mariage-djerba', label: 'Mariage Djerba' },
      { href: '/contact', label: 'Contact' },
    ],
  },
  '/portfolio': {
    paragraphs: [
      'Découvrez nos réalisations photo et vidéo : mariages, clips, corporate et studio à Tunis et Djerba.',
      'Chaque projet reflète notre exigence artistique et notre connaissance du terrain tunisien.',
    ],
    navLinks: [
      { href: '/portfolio/mariage', label: 'Portfolio mariage' },
      { href: '/portfolio/photobooth', label: 'Portfolio photobooth' },
      { href: '/portfolio/corporate', label: 'Portfolio corporate' },
      { href: '/portfolio/shooting', label: 'Portfolio shooting' },
    ],
  },
  '/about': {
    paragraphs: [
      'Fondée en 1988, Lbenna Prod est un studio familial de production audiovisuelle à Tunis et Djerba.',
      'Notre expertise couvre le mariage, l\'événementiel corporate, le photobooth et la production audiovisuelle professionnelle.',
    ],
  },
  '/contact': {
    paragraphs: [
      'Contactez Lbenna Prod pour un devis mariage, photobooth ou film corporate à Tunis et Djerba.',
      'Nous répondons sous 24 h ouvrées par téléphone, email ou formulaire en ligne.',
    ],
  },
  '/faq': {
    paragraphs: [
      'Retrouvez les réponses aux questions les plus fréquentes sur nos prestations photo, vidéo, photobooth et production en Tunisie.',
      'Tarifs, délais, zones d\'intervention et options de livraison : tout est détaillé pour préparer votre projet sereinement.',
    ],
  },
};
